export const cities_data = [
    {
        "id": 1,
        "name": "دنقلا",
        "state_id": 3
    },
    {
        "id": 2,
        "name": "كسلا",
        "state_id": 18
    },
    {
        "id": 3,
        "name": "بورتسودان",
        "state_id": 17
    },
    {
        "id": 4,
        "name": "الدامر",
        "state_id": 5
    },
    {
        "id": 5,
        "name": "عطبرة",
        "state_id": 5
    },
    {
        "id": 6,
        "name": "شندي",
        "state_id": 5
    },
    {
        "id": 7,
        "name": "الدامر",
        "state_id": 5
    },
    {
        "id": 8,
        "name": "القضارف",
        "state_id": 15
    },
    {
        "id": 9,
        "name": "الشوك",
        "state_id": 15
    },
    {
        "id": 10,
        "name": "أم درمان",
        "state_id": 1
    },
    {
        "id": 11,
        "name": "الخرطوم",
        "state_id": 1
    },
    {
        "id": 12,
        "name": "خرطوم بحري",
        "state_id": 1
    },
    {
        "id": 13,
        "name": "المناقل",
        "state_id": 16
    },
    {
        "id": 14,
        "name": "ود مدني",
        "state_id": 16
    },
    {
        "id": 15,
        "name": "الحصاحيصا",
        "state_id": 16
    },
    {
        "id": 16,
        "name": "سنار",
        "state_id": 10
    },
    {
        "id": 17,
        "name": "سنجة",
        "state_id": 10
    },
    {
        "id": 18,
        "name": "أبو حجار",
        "state_id": 10
    },
    {
        "id": 19,
        "name": "كوستي",
        "state_id": 14
    },
    {
        "id": 20,
        "name": "ربك",
        "state_id": 14
    },
    {
        "id": 21,
        "name": "الدويم",
        "state_id": 14
    },
    {
        "id": 22,
        "name": "تندلتي",
        "state_id": 14
    },
    {
        "id": 23,
        "name": "الدمازين",
        "state_id": 13
    },
    {
        "id": 24,
        "name": "الأبيض",
        "state_id": 7
    },
    {
        "id": 25,
        "name": "أم روابة",
        "state_id": 7
    },
    {
        "id": 26,
        "name": "أبو جبيهة",
        "state_id": 7
    },
    {
        "id": 27,
        "name": "أبو حراز",
        "state_id": 7
    },
    {
        "id": 28,
        "name": "أبنوارة",
        "state_id": 7
    },
    {
        "id": 29,
        "name": "الرحمانية",
        "state_id": 7
    },
    {
        "id": 30,
        "name": "الخوى",
        "state_id": 7
    },
    {
        "id": 31,
        "name": "جفاوة",
        "state_id": 7
    },
    {
        "id": 32,
        "name": "غبيش",
        "state_id": 7
    },
    {
        "id": 33,
        "name": "سوق جديد",
        "state_id": 7
    },
    {
        "id": 34,
        "name": "أم صميمة",
        "state_id": 7
    },
    {
        "id": 35,
        "name": "الفولة",
        "state_id": 6
    },
    {
        "id": 36,
        "name": "النهود",
        "state_id": 6
    },
    {
        "id": 37,
        "name": "كادقلي",
        "state_id": 11
    },
    {
        "id": 38,
        "name": "الفاشر",
        "state_id": 8
    },
    {
        "id": 39,
        "name": "الضعين",
        "state_id": 9
    },
    {
        "id": 40,
        "name": "الجنينة",
        "state_id": 2
    },
    {
        "id": 41,
        "name": "نيالا",
        "state_id": 12
    },
    {
        "id": 42,
        "name": "زالنجي",
        "state_id": 4
    }
]

export const states_data = [
    {
        "id": 1,
        "name": "الخرطوم"
    },
    {
        "id": 2,
        "name": "غرب دارفور"
    },
    {
        "id": 3,
        "name": "الشمالية"
    },
    {
        "id": 4,
        "name": "وسط دارفور"
    },
    {
        "id": 5,
        "name": "نهر النيل"
    },
    {
        "id": 6,
        "name": "غرب كردفان"
    },
    {
        "id": 7,
        "name": "شمال كردفان"
    },
    {
        "id": 8,
        "name": "شمال دارفور"
    },
    {
        "id": 9,
        "name": "شرق دارفور"
    },
    {
        "id": 10,
        "name": "سنار"
    },
    {
        "id": 11,
        "name": "جنوب كردفان"
    },
    {
        "id": 12,
        "name": "جنوب دارفور"
    },
    {
        "id": 13,
        "name": "النيل الأزرق"
    },
    {
        "id": 14,
        "name": "النيل الأبيض"
    },
    {
        "id": 15,
        "name": "القضارف"
    },
    {
        "id": 16,
        "name": "الجزيرة"
    },
    {
        "id": 17,
        "name": "البحر الأحمر"
    },
    {
        "id": 18,
        "name": "كسلا"
    }
]

export const localities_data = [
    {
        "id": 5,
        "name": "وادي حلفا",
        "state_id": 3
    },
    {
        "id": 6,
        "name": "دنقلا",
        "state_id": 3
    },
    {
        "id": 7,
        "name": "مروي",
        "state_id": 3
    },
    {
        "id": 8,
        "name": "الدبة",
        "state_id": 3
    },
    {
        "id": 9,
        "name": "نهر عطبرة",
        "state_id": 18
    },
    {
        "id": 10,
        "name": "كسلا",
        "state_id": 18
    },
    {
        "id": 11,
        "name": "القاش",
        "state_id": 18
    },
    {
        "id": 12,
        "name": "همشكوريب",
        "state_id": 18
    },
    {
        "id": 13,
        "name": "ريفي كسلا",
        "state_id": 18
    },
    {
        "id": 14,
        "name": "حلايب",
        "state_id": 17
    },
    {
        "id": 15,
        "name": "سنكات",
        "state_id": 17
    },
    {
        "id": 16,
        "name": "طوكر",
        "state_id": 17
    },
    {
        "id": 17,
        "name": "سواكن",
        "state_id": 17
    },
    {
        "id": 18,
        "name": "جبيت",
        "state_id": 17
    },
    {
        "id": 19,
        "name": "هيا",
        "state_id": 17
    },
    {
        "id": 20,
        "name": "القوليب و أوليب",
        "state_id": 17
    },
    {
        "id": 21,
        "name": "بورتسودان",
        "state_id": 17
    },
    {
        "id": 22,
        "name": "درديب",
        "state_id": 17
    },
    {
        "id": 23,
        "name": "أبوحمد",
        "state_id": 5
    },
    {
        "id": 24,
        "name": "بربر",
        "state_id": 5
    },
    {
        "id": 25,
        "name": "الدامر",
        "state_id": 5
    },
    {
        "id": 26,
        "name": "عطبرة",
        "state_id": 5
    },
    {
        "id": 27,
        "name": "المتمة",
        "state_id": 5
    },
    {
        "id": 28,
        "name": "الفاو",
        "state_id": 15
    },
    {
        "id": 29,
        "name": "الفشقة",
        "state_id": 15
    },
    {
        "id": 30,
        "name": "بلدية القضارف",
        "state_id": 15
    },
    {
        "id": 31,
        "name": "الرهد",
        "state_id": 15
    },
    {
        "id": 32,
        "name": "القلابات الشرقية",
        "state_id": 15
    },
    {
        "id": 33,
        "name": "القلابات الغربية",
        "state_id": 15
    },
    {
        "id": 34,
        "name": "قلع النحل",
        "state_id": 15
    },
    {
        "id": 35,
        "name": "البطانة",
        "state_id": 15
    },
    {
        "id": 36,
        "name": "الفريشة",
        "state_id": 15
    },
    {
        "id": 37,
        "name": "الخرطوم",
        "state_id": 1
    },
    {
        "id": 38,
        "name": "أم بدة",
        "state_id": 1
    },
    {
        "id": 39,
        "name": "أمدرمان",
        "state_id": 1
    },
    {
        "id": 40,
        "name": "كرري",
        "state_id": 1
    },
    {
        "id": 41,
        "name": "الخرطوم بحري",
        "state_id": 1
    },
    {
        "id": 42,
        "name": "شرق النيل",
        "state_id": 1
    },
    {
        "id": 43,
        "name": "جبل أولياء",
        "state_id": 1
    },
    {
        "id": 44,
        "name": "الكاملين",
        "state_id": 16
    },
    {
        "id": 45,
        "name": "شرق الجزيرة",
        "state_id": 16
    },
    {
        "id": 46,
        "name": "الحصاحيصا",
        "state_id": 16
    },
    {
        "id": 47,
        "name": "المناقل",
        "state_id": 16
    },
    {
        "id": 48,
        "name": "مدني الكبرى",
        "state_id": 16
    },
    {
        "id": 49,
        "name": "جنوب الجزيرة",
        "state_id": 16
    },
    {
        "id": 50,
        "name": "أم القرى",
        "state_id": 16
    },
    {
        "id": 51,
        "name": "سنار",
        "state_id": 10
    },
    {
        "id": 52,
        "name": "سنجة",
        "state_id": 10
    },
    {
        "id": 53,
        "name": "الدندر",
        "state_id": 10
    },
    {
        "id": 54,
        "name": "الدويم",
        "state_id": 14
    },
    {
        "id": 55,
        "name": "القطينة",
        "state_id": 14
    },
    {
        "id": 56,
        "name": "كوستي",
        "state_id": 14
    },
    {
        "id": 57,
        "name": "الجبلين",
        "state_id": 14
    },
    {
        "id": 58,
        "name": "أم رمته",
        "state_id": 14
    },
    {
        "id": 59,
        "name": "الدمازين",
        "state_id": 13
    },
    {
        "id": 60,
        "name": "الروصيرص",
        "state_id": 13
    },
    {
        "id": 61,
        "name": "قيسان",
        "state_id": 13
    },
    {
        "id": 62,
        "name": "باو",
        "state_id": 13
    },
    {
        "id": 63,
        "name": "الكرمك",
        "state_id": 13
    },
    {
        "id": 64,
        "name": "كلبس",
        "state_id": 7
    },
    {
        "id": 65,
        "name": "سودري",
        "state_id": 7
    },
    {
        "id": 66,
        "name": "جبرة الشيخ",
        "state_id": 7
    },
    {
        "id": 67,
        "name": "بارا",
        "state_id": 7
    },
    {
        "id": 68,
        "name": "شيكان",
        "state_id": 7
    },
    {
        "id": 69,
        "name": "أم روابة",
        "state_id": 7
    },
    {
        "id": 70,
        "name": "أم دم",
        "state_id": 7
    },
    {
        "id": 71,
        "name": "النهود",
        "state_id": 6
    },
    {
        "id": 72,
        "name": "بابنوسة",
        "state_id": 6
    },
    {
        "id": 73,
        "name": "الفولة",
        "state_id": 6
    },
    {
        "id": 74,
        "name": "هبيلا",
        "state_id": 6
    },
    {
        "id": 75,
        "name": "أبيي",
        "state_id": 6
    },
    {
        "id": 76,
        "name": "الدلنج",
        "state_id": 11
    },
    {
        "id": 77,
        "name": "رشاد",
        "state_id": 11
    },
    {
        "id": 78,
        "name": "أبوجبيهة",
        "state_id": 11
    },
    {
        "id": 79,
        "name": "تلودي",
        "state_id": 11
    },
    {
        "id": 80,
        "name": "كادقلي",
        "state_id": 11
    },
    {
        "id": 81,
        "name": "السلام",
        "state_id": 11
    },
    {
        "id": 82,
        "name": "القوز",
        "state_id": 11
    },
    {
        "id": 83,
        "name": "كليك",
        "state_id": 11
    },
    {
        "id": 84,
        "name": "هبيلا",
        "state_id": 11
    },
    {
        "id": 85,
        "name": "دلامي",
        "state_id": 11
    },
    {
        "id": 86,
        "name": "برام",
        "state_id": 11
    },
    {
        "id": 87,
        "name": "هيبان",
        "state_id": 11
    },
    {
        "id": 88,
        "name": "أم دوربين",
        "state_id": 11
    },
    {
        "id": 89,
        "name": "الريف الشمالي",
        "state_id": 11
    },
    {
        "id": 90,
        "name": "العباسية",
        "state_id": 11
    },
    {
        "id": 91,
        "name": "كلبس",
        "state_id": 8
    },
    {
        "id": 92,
        "name": "مليط",
        "state_id": 8
    },
    {
        "id": 93,
        "name": "كتم",
        "state_id": 8
    },
    {
        "id": 94,
        "name": "كبكابية",
        "state_id": 8
    },
    {
        "id": 95,
        "name": "الفاشر",
        "state_id": 8
    },
    {
        "id": 96,
        "name": "أم كدادة",
        "state_id": 8
    },
    {
        "id": 97,
        "name": "الضعين",
        "state_id": 9
    },
    {
        "id": 98,
        "name": "بحر العرب",
        "state_id": 9
    },
    {
        "id": 99,
        "name": "الفردوس",
        "state_id": 9
    },
    {
        "id": 100,
        "name": "أبو كارنكا",
        "state_id": 9
    },
    {
        "id": 101,
        "name": "شعيرية",
        "state_id": 9
    },
    {
        "id": 102,
        "name": "عديلة",
        "state_id": 9
    },
    {
        "id": 103,
        "name": "أبو جابرة",
        "state_id": 9
    },
    {
        "id": 104,
        "name": "ياسين",
        "state_id": 9
    },
    {
        "id": 105,
        "name": "عسلاية",
        "state_id": 9
    },
    {
        "id": 106,
        "name": "كلبس",
        "state_id": 2
    },
    {
        "id": 107,
        "name": "الجنينة",
        "state_id": 2
    },
    {
        "id": 108,
        "name": "هبيلة",
        "state_id": 2
    },
    {
        "id": 109,
        "name": "بيضة",
        "state_id": 2
    },
    {
        "id": 110,
        "name": "سربا",
        "state_id": 2
    },
    {
        "id": 111,
        "name": "كرينك",
        "state_id": 2
    },
    {
        "id": 112,
        "name": "جبل مون",
        "state_id": 2
    },
    {
        "id": 113,
        "name": "قوز برنقا",
        "state_id": 2
    },
    {
        "id": 114,
        "name": "كاس",
        "state_id": 12
    },
    {
        "id": 115,
        "name": "عد الفرسان",
        "state_id": 12
    },
    {
        "id": 116,
        "name": "نيالا",
        "state_id": 12
    },
    {
        "id": 117,
        "name": "تلس",
        "state_id": 12
    },
    {
        "id": 118,
        "name": "رهيد البردي",
        "state_id": 12
    },
    {
        "id": 119,
        "name": "كنيلا",
        "state_id": 12
    },
    {
        "id": 120,
        "name": "الردوم",
        "state_id": 12
    },
    {
        "id": 121,
        "name": "كتم",
        "state_id": 12
    },
    {
        "id": 122,
        "name": "أم دافوق",
        "state_id": 12
    },
    {
        "id": 123,
        "name": "شاطايا",
        "state_id": 12
    },
    {
        "id": 124,
        "name": "دمسو",
        "state_id": 12
    },
    {
        "id": 125,
        "name": "السلام",
        "state_id": 12
    },
    {
        "id": 126,
        "name": "قريضة",
        "state_id": 12
    },
    {
        "id": 127,
        "name": "شرق الجبل",
        "state_id": 12
    },
    {
        "id": 128,
        "name": "بليل",
        "state_id": 12
    },
    {
        "id": 129,
        "name": "الوحدة",
        "state_id": 12
    },
    {
        "id": 130,
        "name": "مرشح",
        "state_id": 12
    },
    {
        "id": 131,
        "name": "السنطة",
        "state_id": 12
    },
    {
        "id": 132,
        "name": "نتيفا",
        "state_id": 12
    },
    {
        "id": 133,
        "name": "برام",
        "state_id": 12
    },
    {
        "id": 134,
        "name": "زالنجي",
        "state_id": 4
    },
    {
        "id": 135,
        "name": "أزوم",
        "state_id": 4
    },
    {
        "id": 136,
        "name": "وادي صالح",
        "state_id": 4
    },
    {
        "id": 137,
        "name": "مكجر",
        "state_id": 4
    },
    {
        "id": 138,
        "name": "أم دخن",
        "state_id": 4
    },
    {
        "id": 139,
        "name": "جبل مرة ",
        "state_id": 4
    },
    {
        "id": 140,
        "name": "روكورو",
        "state_id": 4
    },
    {
        "id": 141,
        "name": "بندسي",
        "state_id": 4
    }
];
export const markets_data = [
    {
        "id": 1,
        "name": "دنقلا",
        "state_id": 3
    },
    {
        "id": 2,
        "name": "كسلا",
        "state_id": 18
    },
    {
        "id": 3,
        "name": "بورتسودان",
        "state_id": 17
    },
    {
        "id": 4,
        "name": "الدامر",
        "state_id": 5
    },
    {
        "id": 5,
        "name": "القضارف",
        "state_id": 15
    },
    {
        "id": 6,
        "name": "الخرطوم",
        "state_id": 1
    },
    {
        "id": 7,
        "name": "أمدرمان",
        "state_id": 1
    },
    {
        "id": 8,
        "name": "السلام",
        "state_id": 1
    },
    {
        "id": 9,
        "name": "المويلح",
        "state_id": 1
    },
    {
        "id": 10,
        "name": "مدني",
        "state_id": 16
    },
    {
        "id": 11,
        "name": "سنار",
        "state_id": 10
    },
    {
        "id": 12,
        "name": "سنجة",
        "state_id": 10
    },
    {
        "id": 13,
        "name": "كوستي",
        "state_id": 14
    },
    {
        "id": 14,
        "name": "ربك",
        "state_id": 14
    },
    {
        "id": 15,
        "name": "الدمازين",
        "state_id": 13
    },
    {
        "id": 16,
        "name": "ابوجبيهة",
        "state_id": 7
    },
    {
        "id": 17,
        "name": "الابيض",
        "state_id": 7
    },
    {
        "id": 18,
        "name": "الفولة",
        "state_id": 6
    },
    {
        "id": 19,
        "name": "النهود",
        "state_id": 6
    },
    {
        "id": 20,
        "name": "كادقلي",
        "state_id": 11
    },
    {
        "id": 21,
        "name": "الفاشر",
        "state_id": 8
    },
    {
        "id": 22,
        "name": "الضعين",
        "state_id": 9
    },
    {
        "id": 23,
        "name": "الجنينة",
        "state_id": 2
    },
    {
        "id": 24,
        "name": "نيالا",
        "state_id": 12
    },
    {
        "id": 25,
        "name": "زالنجي",
        "state_id": 4
    }
];